// export const PREFIX = 'http://localhost:5000';
export const PREFIX = 'https://api.belong.education';
// export const PREFIX = 'https://development-belong-api.herokuapp.com';

export const UPLOAD_OR_DOWNLOAD_URL = `${PREFIX}/api/upload`;
export const API_URL = `${PREFIX}/api/v2`;
export const USER_BATCH_URL = `${PREFIX}/api/user-batch-details`;
